"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFetchEmergencyContact = void 0;
exports.useUpdateEmergencyContact = useUpdateEmergencyContact;
var _useFetch2 = _interopRequireDefault(require("./useFetch"));
var _useUpdate = require("./useUpdate");
var _api = _interopRequireDefault(require("./api"));
var _toast = require("./toast");
var _endpoints = require("./endpoints");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useFetchEmergencyContact = function useFetchEmergencyContact(patientId) {
  var _useFetch = (0, _useFetch2.default)((0, _endpoints.getPatientEmergencyContactsUrl)(patientId)),
    contactsData = _useFetch.data,
    loading = _useFetch.loading,
    refetchContacts = _useFetch.refetch;
  return {
    contactData: contactsData && contactsData[0],
    loading: loading,
    refetchContacts: refetchContacts
  };
};
exports.useFetchEmergencyContact = useFetchEmergencyContact;
function useUpdateEmergencyContact(_ref) {
  var patientId = _ref.patientId,
    _ref$handleSuccess = _ref.handleSuccess,
    _handleSuccess = _ref$handleSuccess === void 0 ? function () {} : _ref$handleSuccess,
    _ref$handleErrors = _ref.handleErrors,
    _handleErrors = _ref$handleErrors === void 0 ? function () {} : _ref$handleErrors;
  return (0, _useUpdate.useUpdate)({
    update: function update(contact) {
      return _api.default.put((0, _endpoints.getPatientEmergencyContactUrl)(patientId), contact);
    },
    handleSuccess: function handleSuccess() {
      _toast.toast.success({
        title: 'Successfully saved emergency contacts!'
      });
      _handleSuccess();
    },
    handleErrors: function handleErrors() {
      _toast.toast.error({
        title: 'Unable to save emergency contacts. Please try again.'
      });
      _handleErrors();
    }
  });
}